import { IDropdownItem } from '@smartshell/ui-kit';

const ZOOM_OPTIONS: Array<IDropdownItem<number>> = [
  {
    title: '50%',
    value: 0.5,
  },
  {
    title: '75%',
    value: 0.75,
  },
  {
    title: '100%',
    value: 1,
  },
  {
    title: '125%',
    value: 1.25,
  },
  {
    title: '150%',
    value: 1.5,
  },
  {
    title: '175%',
    value: 1.75,
  },
  {
    title: '200%',
    value: 2,
  },
];

export { ZOOM_OPTIONS };
